var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcClose = function SvgIcClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5c.3 0 .5.1.7.3l7 7c.4.4.4 1 0 1.4s-1 .4-1.4 0L12 9.9l-6.3 6.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l7-7c.2-.2.4-.3.7-.3z"
  })));
};
export default SvgIcClose;